import { FormButton } from "../../../components/_input/_button";
import { InputField } from "../../../components/_input/_input";
import axios from "axios";
import { useEffect, useState, useRef, useCallback, createRef } from "react";
import config from '../../../configuration/config.json'
import { formValidate, } from '../../../utils/validation';
import { toast } from "react-toastify";
import Joi from 'joi';
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';

// import {
//     getHash,
//     startOtpListener,
//     useOtpVerify,
//   } from 'react-native-otp-verify';
// import RNOtpVerify from 'react-native-otp-verify';
function SMSCheck({ mobile, onSucess }) {
    const languageDir = 'language-' + localStorage.getItem('i18nextLng');
    const { t: trans, i18n } = useTranslation(["mobileMessages", "mobileCommon", "mobileHeading","error", "mobileInputs", "new"]);
    const bodyRef = useRef(null);
    // const { hash, otp, message, timeoutError, stopListener, startListener } = useOtpVerify({numberOfDigits: 4});
    const [error, setError] = useState({});
    // number of inputs
    const numerOfInputs = 4;

    const refCode1 = createRef();
    const refCode2 = createRef();
    const refCode3 = createRef();
    const refCode4 = createRef();
    // create a array of refs
    const [inputRefsArray] = useState(() =>
        Array.from({ length: numerOfInputs }, () => createRef())
    );
    
    const [correctValidate, setCorrectValidate] = useState(null);


    // useEffect(() => {
    //     getHash().then(hash => {
    //       // use this hash in the message.
    //     }).catch(console.log);

    //     startOtpListener(message => {
    //       // extract the otp using regex e.g. the below regex extracts 4 digit otp from message
    //       const otp = /(\d{4})/g.exec(message)[1];
    //       setOtp(otp);
    //     });
    //     return () => removeListener();
    //   }, []);

    useEffect(() => {
        console.log("refCode1:", refCode1);
        // getHash = () =>
        //     RNOtpVerify.getHash()
        //         .then(console.log)
        //         .catch(console.log);

        // startListeningForOtp = () =>
        //     RNOtpVerify.getOtp()
        //         .then(p => RNOtpVerify.addListener(this.otpHandler))
        //         .catch(p => console.log(p));

        // otpHandler = (message) => {
        //     const otp = /(\d{4})/g.exec(message)[1];
        //     console.log("otp:", otp);
        // }

        window.addEventListener('paste', (event) => {
            let paste = (event.clipboardData || window.clipboardData).getData('text');
            try {
                console.log("paste:", paste);

                var codeNumber = paste.trim().replaceAll('"', "");
                codeNumber = codeNumber.match(/(\d+)/);
                codeNumber = codeNumber[0];
                console.log("codeNumber 11:", codeNumber);
                codeNumber = codeNumber.split('');
                console.log("codeNumber 22:", codeNumber);

                if (codeNumber.length == 4) {
                    const val = { ...requestForm };
                    val.code1 = (codeNumber[0] && !isNaN(codeNumber[0])) ? codeNumber[0] : ''
                    val.code2 = (codeNumber[1] && !isNaN(codeNumber[1])) ? codeNumber[1] : ''
                    val.code3 = (codeNumber[2] && !isNaN(codeNumber[2])) ? codeNumber[2] : ''
                    val.code4 = (codeNumber[3] && !isNaN(codeNumber[3])) ? codeNumber[3] : ''
                    setRequestForm(val);
                }

            } catch (error) {
                console.log("error codeNumber:", error);
            }


        });





        // todo: هذه الفحص خاص بالنسخ sms
        if ('OTPCredential' in window) {
            // toast.error("OTPCredential");
            window.addEventListener('DOMContentLoaded', e => {
                // toast.error("DOMContentLoaded");
                const ac = new AbortController();
                navigator.credentials.get({
                    otp: { transport: ['sms'] },
                    signal: ac.signal
                }).then(otp => {
                    navigator.clipboard.writeText(otp);

                    ac.abort();
                }).catch(err => {
                    console.log(err);
                });
            });
        }


    }, []);


    // state for current input index
    const [currentIndex, setCurrentIndex] = useState(0);
    useEffect(() => {
        document.getElementById("code1").focus();
        callback();

    }, []);


    const handleKeyPress = () => {
        try {
            setCurrentIndex((prevIndex) => {
                // calculate the next input index, next input after the final input will be again the first input. you can change the logic here as per your needs
                const nextIndex = prevIndex < numerOfInputs - 1 ? prevIndex + 1 : 0;
                console.log("inputRefsArray>>>>>>>>>>>>>:" + prevIndex, inputRefsArray);
                const nextInput = inputRefsArray?.[nextIndex]?.current;
                if (nextInput) {
                    nextInput.focus();
                    nextInput.select();
                }
                return nextIndex;
            });

        } catch (error) {
            console.log("error focus:", error);
        }

    };
    const [requestForm, setRequestForm] = useState({
        code1: '',
        code2: '',
        code3: '',
        code4: '',
    });

    const schema = Joi.object({
        code1: Joi.string().max(1).required(),
        code2: Joi.string().max(1).required(),
        code3: Joi.string().max(1).required(),
        code4: Joi.string().max(1).required(),

    });
    const [smsCode, setSmsCode] = useState(null);
    const submitRequest = async (btn) => {
        if (btn) {
            const result = formValidate(schema, requestForm) ?? {};
            setError(result);
        }


        if (timer == "00:00:00") {
            console.log("timer:", timer);
            if (smsCode)
                toast.error(trans("mobileMessages:waiting_period_has_expired"));
            else {
                if (btn){
                    toast.error(trans("mobileMessages:please_wait"));
                }
            }


            return "";
        }
        
        // >>>
        const _codeOtp = requestForm.code1 + requestForm.code2 + requestForm.code3 + requestForm.code4;
         let validCode = await validationOTP({
                 numberPhone: mobile, //todo: نرجع رقم الاصل, // رقم ضيا +966547221619
                 codeOTP:_codeOtp });
         
        // if (smsCode?.Code != "") {
        if (validCode == 1 || validCode == '1') {
            console.log("validCode:", validCode);
            onSucess();
            // console.log("smsCodeee:", smsCode?.Code);
            // const codeEnter = requestForm.code1 + requestForm.code2 + requestForm.code3 + requestForm.code4;
            // if (codeEnter == (smsCode.Code)) {
            //
            //     console.log("okkkkkkkkk:");
            //     // toast.success(trans("mobileMessages:verification_completed_successfully"));

            //     if (onSucess)
            //         onSucess();
            //
            // } else {
            //
            //     if (requestForm.code1 && requestForm.code2 && requestForm.code3 && requestForm.code4)
            //         toast.error(trans("mobileMessages:please_enter_the_correct_code"));
            //
            //
            //
            // }

        } else {

            // toast.error(trans("mobileMessages:please_enter_the_correct_code"));
        }



    }
    //
    // useEffect(() => {
    //     submitRequest(false);
    //
    //
    // }, [requestForm]);


    const handelFocusNext = (currentIndex) => {
        try {
            document.getElementById("code" + (1 + currentIndex)).focus();
        } catch (error) {
            console.log("Catch error handelFocusNext: ", error.toString());
        }
    }

    const handelFocusBack = (currentIndex) => {
        try {
            document.getElementById("code" + (currentIndex - 1 )).focus();
        } catch (error) {
            console.log("Catch error handelFocusBack: ", error.toString());
        }
    }




    const callback = useCallback(async () => {



        console.log("callbackSMSCheck:", mobile);
        try {
            // const Body = {
            //     "name": "Site_SendSmsCodeFormAppFunction",
            //     "values": {
            //         //"to": mobile  // todo: لما يجي يرسسل رمز التحقق  
            //          "to": "+966547221619" // todo رقم ضياء
            //     },
            // }
            // axios.request({
            //     url: config.baseURL + 'func',
            //     data: Body, method: "POST", responseType: "json"
            // })
            //     .then(function (response) {
            //         console.log("response.status >>> :", response.status);
            //         console.log("response.data >>> :", response.data);
            //         console.log("response.data[0] >>> :", response.data[0]);
            //         setSmsCode(response.data[0]);
            //         console.log("smsCodeee:", smsCode?.Code);
            //         clearTimer(getDeadTime());
            //
            //         if ('OTPCredential' in window) {
            //             // window.addEventListener('DOMContentLoaded', e => {
            //
            //             const ac = new AbortController();
            //             navigator.credentials.get({
            //                 otp: { transport: ['sms'] },
            //                 signal: ac.signal
            //             }).then(otp => {
            //                 navigator.clipboard.writeText(otp.code);
            //
            //                 ac.abort();
            //             }).catch(err => {
            //                 console.log(err);
            //             });
            //             // });
            //         }
            //
            //     })
            //     .catch(function (error) {
            //
            //         console.log(error);
            //     });
           await generateSMS()
        } catch (error) {

            console.log("error:", error);
        }



    }, []);

    const  generateSMS = async () => {
        console.log(">>>>>>>>>>> SendSmsCodeFormAppOTP >>>>" );
        console.log("SendSmsCodeFormAppOTP:", mobile);
        try {
            let Body ={
                number: mobile
            }

            await axios.request({
                baseURL: config.controllerUrl,
                // 
                url: `sadad/api/Maintenance/SendSmsCodeFormAppOtp`,
                // headers: myHeaders,
                data: Body, method: "POST", responseType: "json"
            }).then(
                async response =>{
                console.log('SendSmsCodeFormAppOTP response:', response);
                if (response.status >= 200 && response.status <= 299) {
                    console.log("SendSmsCodeFormAppOTP response.data: ",response.data);
                    if(response.data.status == 200){
                        console.log("SendSmsCodeFormAppOTP response.data:code: ",response.data.code);
                        clearTimer(getDeadTime());
                    }else {
                         // toast.error(trans("mobileMessages:please_enter_the_correct_code"));
                        toast.error(trans("error:error_verification_code"));
                        
                        console.log("SendSmsCodeFormAppOTP response.data:status: ",response.data.status);
                    }
                }
            }).catch(async err=>{
                toast.error(trans("error:error_verification_code"));
                console.info("Error catch SendSmsCodeFormAppOtp",err);
            })
            
        }catch (ex) {
            toast.error( trans("error:error_verification_code"));
            console.log(ex,"Ex catch:", ex);
        }
    }

// * ValditionOTP
    const  validationOTP = async ({numberPhone, codeOTP} ) => {
        console.log(">>>>>>>>>>> SendSmsCodeFormAppOTP >>>>",numberPhone, "||",codeOTP );
        console.log("SendSmsCodeFormAppOTP:", mobile);
        let correct = 0;
        try {
            let Body ={
                number: numberPhone, //  `+966547221619`, // mobile
                code: codeOTP
            }

            await axios.request({
                baseURL: config.controllerUrl,
                // 
                url: `sadad/api/Maintenance/ValditionOTP`,
                // headers: myHeaders,
                data: Body, method: "POST", responseType: "json"
            }).then(
                async response =>{
                    console.log('ValditionOTP response:', response);
                    if (response.status >= 200 && response.status <= 299) {
                        console.log("ValditionOTP response.data: ",response.data);
                        if(response.data.Correct == 1){
                            console.log("ValditionOTP response.data.Correct: ",response.data.Correct);
                            // setCorrectValidate(true);
                            // return correct; // 1 true
                            correct = response.data.Correct;
                        }
                        else {
                            // setCorrectValidate(false);
                            // toast.error(trans("mobileMessages:please_enter_the_correct_code"));
                            toast.warn(trans("error:error_otp"));
                            console.log("ValditionOTP response.data.Correct: ",response.data.Correct);
                        }
                    }
                }).catch(async err=>{
                toast.error("error:verification_code");
                console.info("Error catch SendSmsCodeFormAppOtp",err);
            })

        }catch (ex) {
            toast.error("error:verification_code");
            console.log(ex,"Ex catch:", ex);
        }
        
        return correct;
    }
    
    


    // We need ref in this, because we are dealing
    // with JS setInterval to keep track of it and
    // stop it when needed
    const Ref = useRef(null);

    // The state for our timer
    const [timer, setTimer] = useState('00:00:00');


    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        };
    }


    const startTimer = (e) => {
        let { total, hours, minutes, seconds }
            = getTimeRemaining(e);
        if (total >= 0) {

            // update the timer
            // check if less than 10 then we need to 
            // add '0' at the beginning of the variable
            setTimer(
                (hours > 9 ? hours : '0' + hours) + ':' +
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            )
        }
    }


    const clearTimer = (e) => {

        // If you adjust it you should also need to
        // adjust the Endtime formula we are about
        // to code next    
        setTimer('00:02:00');

        // If you try to remove this line the 
        // updating of timer Variable will be
        // after 1000ms or 1sec
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }

    const getDeadTime = () => {
        let deadline = new Date();

        // This is where you need to adjust if 
        // you entend to add more time
        deadline.setSeconds(deadline.getSeconds() + 120);
        return deadline;
    }

    // We can use useEffect so that when the component
    // mount the timer will start as soon as possible

    // We put empty array to act as componentDid
    // mount only
    // useEffect(() => {
    // }, []);

    // Another way to call the clearTimer() to start
    // the countdown is via action event from the
    // button first we create function to be called
    // by the button
    const onClickReset = () => {
        clearTimer(getDeadTime());
    }

    return (
        <div ref={bodyRef} className={`sms-check-page container mb-32 nice-apply-theme `}>


            <div className="container  nice-apply-theme">
                <div className="sms-check-top my-20">
                    <h3 className="text-60 my-10 text-bold text-center"> {trans("mobileMessages:check_text_messages")}   </h3>
                    <h3 className="text-40 my-10 text-gray text-center">{smsCode && trans("mobileMessages:sent_you_code")}</h3>
                    
                        <h3 className="language-en text-40  my-10 text-info text-center">
                            {
                                mobile?.substr(0, 3) + "****" + mobile?.substr(7, 8)
                                // mobile?.substr(0, 6) + "****" + mobile?.substr(10, 12)
                            }
                        </h3>
                    
                    <div className=""
                        style={{ height: "0.3rem", background: "#9aa69d" }}
                    ></div>
                </div >

                <h3 className="text-40 my-10 text-gray text-center"> {trans("mobileMessages:enter_code")}</h3>


                <div className="flex flex-nowrap nice-gap-5rem flex-wrap language-en">
                    <div className="grow">
                        <InputField
                            autoComplete="one-time-code"
                            placeholder={"0"}
                            id={"code1"}
                            language={"language-en"}
                            refValue={refCode1}
                            value={requestForm.code1}
                            type='text'
                            inputMode="numeric"
                            pattern="[0-9]*"
                            length={1}
                            style={{ height: "15rem", fontSize: "8rem", textAlign: "center" }}
                            extraClasses={"nice-shadow"}

                            errorLabel={error?.code1}
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.code1 = e.target.value;
                                setRequestForm(val);

                                if (e.target.value && e.target.value != "")
                                    handelFocusNext(1);
                                else {
                                    // if(e.target.value.length == 0 && e.target.value == ""){
                                    console.log("e.value = 0? >>>>",e.target.value);
                                    handelFocusBack(1);
                                }



                                if (e.target.value) {
                                    // console.log("refCode2", refCode2)
                                    // refCode2.focus();
                                }
                            }}
                            name='code1'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={"0"}
                            refValue={refCode2}
                            id={"code2"}
                            language={"language-en"}

                            value={requestForm.code2}
                            type='text'
                            inputMode="numeric"
                            pattern="[0-9]*"
                            length={1}
                            style={{ height: "15rem", fontSize: "8rem", textAlign: "center" }}
                            extraClasses={"nice-shadow"}
                            errorLabel={error?.code2}
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.code2 = e.target.value;
                                setRequestForm(val);
                                if (e.target.value && e.target.value != "")
                                    handelFocusNext(2);
                                else {
                                    // if(e.target.value.length == 0 && e.target.value == ""){
                                    console.log("e.value = 0? >>>>",e.target.value);
                                    handelFocusBack(2);
                                }
                            }}
                            name='code2'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            placeholder={"0"}
                            id={"code3"}
                            refValue={refCode3}
                            language={"language-en"}
                            value={requestForm.code3}
                            type='text'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            length={1}
                            style={{ height: "15rem", fontSize: "8rem", textAlign: "center" }}
                            extraClasses={"nice-shadow"}
                            errorLabel={error?.code3}
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.code3 = e.target.value;
                                setRequestForm(val);
                                if (e.target.value && e.target.value != "")
                                    handelFocusNext(3);
                                else {
                                    // if(e.target.value.length == 0 && e.target.value == ""){
                                    console.log("e.value = 0? >>>>",e.target.value);
                                    handelFocusBack(3);
                                }
                            }}
                            name='code3'
                        />
                    </div>
                    <div className="grow">
                        <InputField
                            id={"code4"}
                            placeholder={"0"}
                            refValue={refCode4}
                            language={"language-en"}
                            value={requestForm.code4}
                            type='text'
                            pattern="[0-9]*"
                            inputMode="numeric"
                            length={1}
                            style={{ height: "15rem", fontSize: "8rem", textAlign: "center" }}
                            extraClasses={"nice-shadow"}
                            errorLabel={error?.code4}
                            onChangeValue={(e) => {
                                const val = { ...requestForm };
                                val.code4 = e.target.value;
                                setRequestForm(val);
                                if (e.target.value && e.target.value != "")
                                    handelFocusNext(4);
                                else {
                                    // if(e.target.value.length == 0 && e.target.value == ""){
                                    console.log("e.value = 0? >>>>",e.target.value);
                                    handelFocusBack(4);
                                }
                            }}
                            name='code4'
                        />


                    </div>
                </div>

                <h3 className="text-40 my-10 text-gray text-center"> {timer}  </h3>

                <FormButton name={trans("new:continue")}
                    //  isLoading={isLoading} 
                    classes={"text-40"}
                    onClick={() => submitRequest(true)}

                />

                <div className="sms-check-footer my-10 flex justify-between">

                    <Link to={"#"} className="text-30  text-gray text-center"

                        onClick={(e) => {
                            e.preventDefault();

                        }}
                    > {trans("mobileMessages:not_receive_the_code")}  </Link>

                    <Link to={"#"} className="text-30  text-info text-center"
                        onClick={(e) => {
                            e.preventDefault();
                            if (timer == "00:00:00") {
                                callback();
                            }

                        }}

                    > {trans("mobileMessages:resend")}  </Link>

                </div>

            </div >
        </div >
    );
}

export default SMSCheck;
